import { Link } from 'react-router-dom';

import type { JSX } from 'react';

export function ForbiddenPage(): JSX.Element {
  return (
    <main className="flex min-h-screen flex-col items-center justify-center px-4 text-center">
      <p className="text-sm font-semibold uppercase tracking-wider text-slate-500">Erreur 403</p>
      <h1 className="mt-2 text-3xl font-bold text-slate-900">Accès refusé</h1>
      <p className="mt-3 max-w-md text-slate-600">
        Votre compte n'a pas les permissions nécessaires pour accéder à cette page.
      </p>
      <Link
        to="/"
        className="mt-6 inline-flex items-center rounded-md bg-slate-900 px-4 py-2 text-sm font-medium text-white hover:bg-slate-800 focus:outline-none focus:ring-2 focus:ring-slate-900 focus:ring-offset-2"
      >
        Retour à l'accueil
      </Link>
    </main>
  );
}
